<template>
  <div class="pt-8">
    <h2 
      class="customTitle"
      v-text="thisUserType == 'challenger' ? '나의 일기' : '파트너의 일기'"
    ></h2>
    <p style="font-size: 14px;">[ {{ selectedDate }} ]</p>
    <div 
      v-if="!diaryList || diaryList.length == 0"
      class="contentsNone"
    >
      <p class="mb-2">
        <v-icon>mdi-alert</v-icon>
      </p>
      <div class="text-center">일기가 없습니다.</div>
    </div>
    <div 
      v-else 
      id="diary-slide"
    >
      <!-- <div
        class="diary-card"
        v-for="diary in diaryList"
        :key="'diary-' + diary.id"
        @click="$router.push('/diary/detail?id=' + diary.id)"
      > -->
      <div
        class="diary-card"
        v-for="diary in diaryList"
        :key="'diary-' + diary.id"
        @click="$router.push('/diary/detail')"
      >
        <div class="diary-top">
          <p class="diary-title">{{ diary.title }}</p>
          <span
            v-if="diary.is_passed === true"
            class="badge"
          >확인</span>
          <span
            v-if="diary.is_passed === false"
            class="badge reject"
          >거절</span>
        </div>
        <p class="diary-text" v-html="diary.text"></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DiaryList",
  props: {
    userType: {
      type: String
    },
    selectedDate: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      diaryList: undefined,
    };
  },
  computed: {
    thisUserType() {
      return this.userType;
    },
  },
  watch: {
    selectedDate(v) {
      this.getDiaryList();
    },
  },
  methods: {
    getDiaryList() {
      this.diaryList = undefined;
      // this.$axios.get('/challenges/' + this.$store.getters.challengeId + '/diaries?date=' + this.selectedDate).then(response => {
      //   this.diaryList = response.data;

      //   if(this.$store.getters.finished) {
      //     this.$emit('checked', false);
      //   } else if (this.diaryList.length == 0 || this.diaryList[0].is_passed === false) {
      //     this.$emit('checked', true);
      //   } else {
      //     this.$emit('checked', false);
      //   }
      //   return;

      //   // if(!this.$store.getters.finished || !this.diaryList || (this.diaryList.length == 0 && this.diaryList[0].is_passed === false)){
      //   //   this.$emit('checked', true);
      //   // } else {
      //   //   this.$emit('checked', false);
      //   // }
      //   // if(!this.$store.getters.finished || !this.diaryList || (this.diaryList.length == 0 && this.diaryList[0].is_passed === false)){
      //   //   this.$emit('checked', true);
      //   // } else {
      //   //   this.$emit('checked', false);
      //   // }
      // });
      this.diaryList = [
        {
          id: 1,
          title: "타이틀입니다.",
          is_passed: true,
          text: "일기 내용입니다."
        }
      ];
    },
  },
};
</script>

<style scoped lang="scss">
#diary-slide {
  overflow-x: scroll;
  white-space: nowrap;

  .diary-card {
    width: 160px;
    margin-right: 32px;
    position: relative;
    display: inline-block;
    cursor: pointer;

    .diary-top{
      position: relative;

      .diary-title {
        width: 100%;
        padding-bottom: 8px;
        padding-right: 24px;
        margin-bottom: 8px;
        border-bottom: 1px solid #ccc;
        font-size: 14px;
        font-weight: 700;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-wrap: normal;
        overflow: hidden;
      }
      .badge {
        width: 22px;
        height: 22px;
        border-radius: 100%;
        position: absolute;
        top: 0px;
        right: 0px;
        text-indent: -9999px;
        background: url('../../assets/images/common/icon_check.svg') no-repeat center center #ffdc25;
        background-size: 56%;

        &.reject{
          background: url('../../assets/images/common/icon_reject.svg') no-repeat center center #ce0c0c;
          background-size: 56%;
        }
      }
    }
    .diary-text {
      height: 20px;
      color: black;
      line-height: 20px;
      font-size: 14px;
      overflow: hidden;
    }
  }
}
</style>
<style lang="scss">
.diary-text {
  p{
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>